// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vw238","container__text":"styles_container__text__LzPSA","skeleton-animation":"styles_skeleton-animation__FT6c_"};